<template>
    <!--   <div  class="swiper-container" :style="{width:'100px;'}">
   <div class="swiper-wrapper"> -->
    <!--80vh 去除底部 padding-->
    <div>
        <Row style="background-color: white;height: 100vh;">
            <Col :span="mainPageSpan" :class="{activeBar: isButtonActive }">
            <Button type="primary" @click="toggleMenu" :icon="isButtonActive?'md-arrow-round-forward':'md-arrow-round-back'" :style="{
                width:isButtonActive?'40px':'40px',
                height:!isjxt?'60px':'40px',
                borderRadius:'0px',
                boxShadow:'none',
                display:hiddenButtonShow?'block':'none',
                position:'absolute',
                zIndex:'999',
                right:'0px',
                fontSize:!isjxt?'30px':'25px',
                border:'none'}" size="small"></Button>
            <div class="layout" :style="{display:mainHidden?'none':'block'}">
                <Layout>
                    <header v-show="!isjxt">
                        <TopHeader @removeAll="sliderRemoveAll" @loginOK="onLoginOK" @reloadDoc="reloadFile" @filematch="gofileMatch" ref="topheader"></TopHeader>
                    </header>
                    <header v-show="isShowTopMenu">
                        <TopMenu ref="topMenuModal"></TopMenu>
                    </header>
                    <div style="position: relative;">
                        <!-- <Content class="content" :style="{padding:'0px',height:swiperSlides.length===0?'81.0vh':swiperSlides.length>0?'78.2vh':'78.2vh'}"> -->
                        <Content :class="swiperSlides.length==0?'content_f':!isjxt?'content':'content_g1'">
                            <router-view></router-view>
                        </Content>
                        <Spin fix v-if="isShowSpin"></Spin>
                    </div>
                    <!-- <Footer class="footer" :style="{padding:autoFixHeight?'8px 8px':'5px 5px'}">
                        <Row>
                            <Col span="1">
                            <div @click="openQR">
                                <img id="qrimg" style="width:60px;height: 60px;cursor:pointer;" src="../assets/images/mobileqrcode.png">
                            </div>
                            </Col>
                            <Col span="23">
                            <div style="text-align: center;">
                                <div style="padding-top: 15px;"><a @click="statement">特别声明</a> | <a @click="feedback">意见反馈</a> | <a href="http://beian.miit.gov.cn/" target="_black">蜀ICP备20000433号-1</a> | <span style="color:#A8ACB9;">服务热线：028-66612366</span>
                                </div>
                                <div type="text" style="box-shadow:none;color: #878F9B;" size="small" ghost>Copyright © 2020 www.holywiser.com 众智云擎 版权所有 </div>
                            </div>
                            </Col>
                        </Row>
                    </Footer> -->
                </Layout>
            </div>
            </Col>
            <Col :span="sliderMainPageSpan">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="slide in swiperSlides" :key="slide.key" :style="{width:nextSliderWidth}">
                    <MyDocument :ref="slide.key" @remove="sliderRemove(slide)" :message="slide.fileid" :docid="slide.docid" :pageindex="slide.index" :orderid="ordertypeid" :gorow="goRow" :key="slide.index" @onOpen="add" @onDocFinished="update"></MyDocument>
                </swiper-slide>
                <div class="swiper-scrollbar" slot="scrollbar" style="height: 15px;"></div>
            </swiper>
            </Col>
        </Row>
        <Modal v-model="isShowQRCode" width="500" :mask-closable="true" :closable="false">
            <div style="display: flex;flex-direction: column;width: 460px;align-items: center;">
                <div style="justify-content: center;width: 400px;height: 300px;display: flex;align-items: center;">
                    <img src="../assets/images/mobileqrcode.png" width="200px" height="200">
                </div>
                <h3>扫码进入移动云擎</h3>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeQR">关闭</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import eventBus from "../components/common/event_bus.js"
import Vue from 'vue'
import TopHeader from './top_header'
import TopMenu from './top_menu'
import MyDocument from './common/doc/docpage.vue'
import Drawer from './common/doc/drawerpage.vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { uuid } from 'vue-uuid'
import store from '../store'
import ConstJson from "../api/common/constjson.js"
let constJ = new ConstJson()
// const aComponent = Vue.extend({
//   props: ['text'],
//   template: `<swiper-slide>
//         <Layout>
//           <Header><Button type="error" size="large" v-on:click="$emit(\'remove\')">close</Button></Header>
//           <Content :style="{height:'86.5vh'}">{{text}}</Content>
//           <Footer :style="{background:'#515a6e',color:'white'}">Footer</Footer>
//         </Layout>
//         </swiper-slide>`

// })
export default {

    data() {
        let that = this;
        return {
            isShowTopMenu:true,
            isShowSpin: false,
            swiperOption: {
                watchOverflow: true,
                slidesPerView: 'auto',
                // slidesPerView: 1, 
                // slidesPerColumn:1,
                spaceBetween: 3,
                freeMode: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    snapOnRelease: false,
                    //dragSize:200,
                },
                //effect : 'flip',
                // pagination: {
                //   el: '.swiper-pagination',
                //   clickable: true

                // },
                on: {
                    slideChange: function() {
                        //console.log(this.activeIndex);
                        // if (this.activeIndex > 0) {
                        //   that.showMainList()
                        // } else {
                        //   that.closeMainList()
                        // }
                    },

                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            },
            roadmap: [], //{key:"home",value:"Home"},{key:"detail",value:"searchresult"}
            iconsize: 20,
            items: [],
            isRouterAlive: false,
            swiperSlides: [],
            msg: "",
            pindex: 0,
            goRow: {},
            ordertypeid: 0,
            // mainPageWidth: "100%", //主页宽度
            nextSliderWidth: "100%", //slider页宽度
            expand: false, //主页展开状态
            expandButtonSize: 'normal', //主页顶部控制按钮大小
            mainHidden: false, //是否显示主屏内容
            hiddenButtonShow: false, //主页顶部控制按钮
            mainPageSpan: "24", //主页内容宽度
            sliderMainPageSpan: "0", //slider页面宽度
            isButtonActive: false, //是否激活边栏宽度样式
            toggleFullScreen: false, //点击toggle()进入单页全屏模式
            //uuid:uuid.v1(),
            autoFixHeight: false,
            isShowQRCode: false,
            isjxt:store.state.user.isjxt,//false 不显示header，true显示header
        }
    },
    watch: {
        swiperSlides: function() {
            console.log(this.swiperSlides)
            //this.reloadFooter()
            //let a=this.swiperSlides[0].key
            //this.gosort(this.swiperSlides)
            //console.log("swiperSlides:"+this.swiperSlides.length)
            // this.$refs.mySwiper.update();
            // this.swiper.slideNext();
            if (this.swiperSlides.length > 0) {
                this.$refs.topheader.showMultiBtn(true)
                this.$refs.topMenuModal.showMultiBtn(true)
                //add button menu show more at 20230129 
                this.$refs.topMenuModal.isShowMoreMenu = true
                if (this.swiperSlides.length > 1) {
                    this.$refs.topMenuModal.showMultiBtn(false) //动态控制登录菜单最后一项的显示
                }

            } else {
                this.$refs.topheader.showMultiBtn(false)
                this.$refs.topMenuModal.showMultiBtn(true) //动态控制登录菜单最后一项的显示
            }
        },
        sliderScreen: function() {
            console.log("watch sliderlength=" + this.sliderLength)
            if (this.sliderLength >= 2) {
                if (this.sliderScreen === true) {
                    //this.setSliderOne();
                }
            }
        },
        // '$route':function(v){
        //     console.log('$route==>')
        //     console.log(v.name)
        //     if(v.name=='filematch'){
        //         this.isShowTopMenu=false
        //     }else{
        //         this.isShowTopMenu=true
        //     }
        // }
    },
    provide() {
        return {
            CreatePage: this.add,
            reload: this.reload,
            Back: this.back,
            getSliders: this.getTotalSliders,
            feedbackMsg: '',
            isShowLoading: true,
            removeAllSliders: this.removeAll,
            setTopMenuStyle: this.topMenuStyle,
            setFileMatchIndex:this.gofileMatch,
            setJdSearchIndex:this.goJdSearch,
            setTaxChatIndex:this.gotaxchat,
            setRiskDetectionIndex:this.goRiskdetection,
        }
    },
    methods: {
        // gosort(sliders){
        //     let newArr=[]
        //     if(sliders.length>0){
        //         for(let i =0;i<sliders.length;i++){
        //             sliders[i].index=i
        //             let s= sliders[i]
        //             newArr.push(s)
        //         }
        //     }
        //     console.log('=======')
        //     console.log(newArr)
        // },
        gotaxchat(){
            this.$refs.topMenuModal.actname = "14"
        },
        gofileMatch(){
            this.$refs.topMenuModal.actname = "12"
        },
        goJdSearch(){
            this.$refs.topMenuModal.actname = "8"
        },
        goRiskdetection(){
             this.$refs.topMenuModal.actname = "15"
        },
        topMenuStyle() {
            //set topmenu activename=1 
            this.$refs.topMenuModal.actname = "1"
        },
        removeAll() {
            console.log('removeAll swiperslides...')
            this.swiperSlides = []
            this.$nextTick(function() {
                this.$refs.mySwiper.update();
                this.resize();
                this.expand = false;
                this.mainHidden = false
            })
            this.setSysSliders([])
            //clear audios
            eventBus.$emit('audiotts-stop-force')
        },
        onLoginOK() {
            //this.$refs.topMenuModal.showTopMenuByAccountType()
        },
        setSysSliders(sliders) {
            store.state.user.sliders = sliders
        },
        getSysSliders() {
            return store.state.user.sliders
        },
        openQR() {
            this.isShowQRCode = true
        },
        closeQR() {
            this.isShowQRCode = false
        },
        setFooterPad() {
            //chrome无navbar 969,有navbar 937,edge967/935,firefox966/944
            //<=944 5px 5px,>944 8px 8px 
            let height = window.innerHeight;
            if (height > 944) {
                this.autoFixHeight = true
            } else {
                this.autoFixHeight = false
            }

        },
        statement() {
            this.$refs.topheader.showStateMent()
        },
        sendFeedBack(msg) {
            var params = {}
            params.suggestions = msg
            constJ.reqCreateFeedBack(params).then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('意见反馈发送成功')
                        this.$Message.success("非常感谢您的反馈");
                        //this.$Modal.remove()
                    } else {
                        console.log(res.rltdesc)
                        this.$Message.warning(res.rltdesc);
                        //this.$Modal.remove()
                    }
                } else {
                    console.log(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        checkUserLogin() {
            //console.log(store.state.user.userId)
            if (store.state.user.userId === undefined || store.state.user.userId === "") {
                return false
            } else {
                return true
            }
        },
        feedback() {
            //this.$Modal.config.width=500
            this.feedbackMsg = ''
            var that = this
            if (!this.checkUserLogin()) {
                this.$Message.warning("请先登录您的账号")
                return
            }
            this.$Modal.confirm({
                title: '意见和建议',
                width: '600px',
                onOk: (value) => {
                    //console.log(that.feedbackMsg)
                    if (this.feedbackMsg !== '' && this.feedbackMsg.length > 0) {
                        //提交到接口
                        this.sendFeedBack(this.feedbackMsg)
                        //this.$Message.success("非常感谢您的反馈");
                    } else {
                        //this.$Message.warning("请输入您的意见或建议");
                        //console.log(this.$Modal.props.loading.default)
                        return
                    }
                },
                onCancel: () => {
                    //this.$Message.info('Clicked cancel');
                },
                render: (h) => {
                    return h('Input', {
                        props: {
                            value: this.feedbackMsg,
                            autofocus: true,
                            placeholder: '请留下您的宝贵意见...',
                            type: 'textarea',
                            rows: 20,
                            size: 'large',

                        },
                        on: {
                            input: (val) => {
                                this.feedbackMsg = val;
                            }
                        },

                    })
                }
            })

        },
        checkicp() {
            window.open('http://beian.miit.gov.cn/')
        },
        // userLogin(redirectUrl){
        //   this.$refs.topheader.otherShowlogin(redirectUrl)
        //   //console.log("go.....")
        // },
        isIE() {
            let isIE = this.$Tools.getBrowserVersion().isIE
            let host = this.$baseConfig.host
            if (isIE) {
                this.$Message.warning({
                    render: h => {
                        return h('div', ['使用现代浏览器:', h('a', {
                            // on: {
                            //   click:this.download
                            // },
                            attrs: {
                                href: 'Microsoft-edge:' + host,
                            },
                        }, 'Edge'), '或', h('a', {
                            attrs: {
                                href: 'https://www.google.cn/chrome/',
                                target: '_black'
                            },
                        }, 'Chrome'), '以获得更好的体验'])
                    },
                    duration: 0,
                    closable: true,
                    background: true,
                })
            }
        },
        reloadFile() {
            console.log(this.swiperSlides)
            for (let s of this.swiperSlides) {
                var ref = s.key
                //console.log(this.$refs[ref][0].$refs.docmentplay)
                this.$refs[ref][0].$refs.docmentplay.loadDoc(s.fileid)
            }
        },
        resetPlayState(playerid){
            for (let s of this.swiperSlides) {
                var ref = s.key
                if(this.$refs[ref][0].$refs.docmentplay.docname!=playerid){
                    this.$refs[ref][0].$refs.docmentplay.isPlay=false
                    this.$refs[ref][0].$refs.docmentplay.isPause=false
                }
                
            }
        },
        resetPlayStateOnFinished(playerid){
             for (let s of this.swiperSlides) {
                var ref = s.key
                if(this.$refs[ref][0].$refs.docmentplay.docname==playerid){
                    this.$refs[ref][0].$refs.docmentplay.isPlay=false
                    this.$refs[ref][0].$refs.docmentplay.isPause=false
                }
            }
        },
        reloadFooter() {
            //关闭页面时,动态计算页码
            let i = 0
            for (let s of this.swiperSlides) {
                var ref = s.key
                let max = this.swiperSlides.length
                let index = max - i
                this.$refs[ref][0].setIndex(index)
                i++
                //console.log(this.$refs[ref][0].setIndex(max))
                //this.$refs[ref][0].$refs.docmentplay.loadDoc(s.fileid)
            }
        },

        // reloadSliders(sliders) {
        //   this.sliderRemoveAll(sliders)
        //   if (sliders !== undefined && sliders.length > 0) {
        //     for (let s of sliders) {
        //        console.log(s)
        //        this.add(s.fileid,1,s.filename)
        //     }

        //   }
        // },
        //fileid=文件id, 
        //orderid=docpange呈现的样式标识, 
        //filename=文档名,
        //row=点击table中某一行数据返回该行的object
        add(fileid, orderid, filename, row) {
            //orderid=1打开一个政策文档，orderid=2打开一个工作薄文档
            console.log('add page...')
            console.log(fileid, orderid, filename)
            console.log(row)
            this.goRow = row
            if (orderid === undefined || orderid === "" || orderid === null) {
                orderid = 1
            }

            if (this.sliderLength === 0) {
                //console.log("sliderLength=0,set expand=true")
                this.expand = true
            }

            //this.prependSlide(fileid, filename);
            this.prependSlide(fileid.toString(), filename, row);
            this.msg = fileid.toString();
            this.ordertypeid = orderid
            //console.log(this.msg)
            //console.log("main add orderid:" + orderid)
            //console.log(this.$refs)
        },
        //打开文档后更新swiperSlides对应的item docid和filename
        update(itemrow, orderid) {
            console.log("update list...")
            if (orderid === undefined || orderid === "" || orderid === null) {
                orderid = 1
            }
            let fileid = itemrow.strdocid.toString()

            //console.log("fileid:" + fileid, "orderid:" + orderid, "filename:" + filename)
            var has = this.swiperSlides.some((item) => { return item.fileid === fileid });
            if (has) {
                const findelement = this.swiperSlides.find(element => element.fileid === fileid)
                //console.log(findelement)
                findelement.filename = itemrow.fname
                findelement.docid = itemrow.docid
                return
            }

        },
        swiperNext() {
            this.swiper.slideNext();
        },
        back() {
            this.swiper.slideTo(0);
        },
        prependSlide(fileid, fname, row) {
            //console.log(fileid,fname)
            //console.log(this.swiperSlides)
            //分支1:将用阅读过的文档缓存到列表
            //如果在编辑工作薄状态下则加入到已读文件列表2018.11.26 add by alan

            var file = { fileid: fileid, filename: fname, index: 0, key: uuid.v1(), docid: row !== undefined ? row.docid : 0 }
            this.addReadFile(file)

            //分支2:将用户打开的文档分屏显示
            //验证是否开启的是已存在的文档
            var has = this.swiperSlides.some((item) => { return item.fileid === fileid });
            if (has) {
                //get from store sliders,page index count again
                let list = this.getSysSliders()
                for (let index in list) {
                    list[index].index = list.length - index
                }
                this.setSysSliders(list)


                //const findelement = this.swiperSlides.find(element => element.fileid === fileid)
                //console.log("slider.index:" + findelement.index);
                const findelement = list.find(element => element.fileid === fileid)
                //向后滚动,索引是倒序，所以应该交换index位置
                let slideToIndex = this.swiperSlides.length - findelement.index
                console.log("slideToIndex:" + slideToIndex)
                let pageIndex = this.swiperSlides.length - slideToIndex
                console.log("pageIndex:" + pageIndex)
                this.openNotice(false, pageIndex);
                this.swiper.slideToLoop(slideToIndex, 2000);
                //console.log(this.getSysSliders())
                return
            }

            //验证是否超出限定的文档数量,根据配置默认初始数量

            //let CODE_FUNC_SCREEN = "000011"
            let CODE_FUNC_SCREEN = this.$Tools.getPermission().CODE_FUNC_SCREEN
            let pages = store.state.user.sysconfig.pages - 1
            let permissions = store.state.user.permission
            console.log(permissions)
            console.log(store.state.user.permission)
            if (permissions && permissions.length > 0) {
                let node = permissions.find(p => p.f === CODE_FUNC_SCREEN)
                console.log("CODE_FUNC_SCREEN:" + node)
                if (node) {
                    pages = node.n - 1 //store.state.user.permission[10].n
                } else {
                    this.$Message.warning('无分屏权限，请前往在线商城购买')
                    return
                }

            }
            console.log("pages" + pages)

            // let pages = store.state.user.sysconfig.pages - 1
            // if (store.state.user.permission && store.state.user.permission.length > 0) {
            //     pages = store.state.user.permission[10].n - 1
            // }

            if (this.swiperSlides.length > pages) {
                this.instance('warning');
                return;
            }
            //新增时自动滚动到第一个
            this.swiper.slideToLoop(0, 2000);

            this.pindex = this.swiperSlides.length + 1;
            var swiperobj = { fileid: fileid, filename: fname, index: this.pindex, key: uuid.v1(), docid: row !== undefined ? row.docid : 0 }
            //this.swiperSlides.unshift(this.swiperSlides[1] - 1)
            this.swiperSlides.unshift(swiperobj)
            //console.log(this.swiperSlides);
            this.$nextTick(function() {
                this.$refs.mySwiper.update();
                this.resize();
            })
            this.setSliderLength(this.swiperSlides.length);

            //save to store
            this.setSysSliders(this.swiperSlides)
            //console.log(this.sliderLength)

        },
        sliderRemove(slide) {
            console.log('remove slider')
            // sliders.splice(sliders.findIndex(item => item.fileid === slide.fileid), 1);
            // this.swiperSlides = sliders;
            this.swiperSlides.splice(this.swiperSlides.findIndex(item => item.fileid === slide.fileid), 1);
            //porps数据变化会导致在关闭分屏页面时触发子页mounted
            // for (let index in this.swiperSlides) {
            //     //console.log(this.swiperSlides.length-index)
            //     this.swiperSlides[index].index = this.swiperSlides.length - index
            // }
            //计算页码
            this.reloadFooter()

            this.setSliderLength(this.swiperSlides.length);
            // console.log(sliders);
            this.$nextTick(function() {
                this.$refs.mySwiper.update();
                if (this.sliderLength === 0) {
                    this.expand = false
                    this.mainHidden = false
                    this.toggleFullScreen = false
                }
                this.resize();
            })

            ////save to store
            this.setSysSliders(this.swiperSlides)
            //console.log("remove,sliderLength=" + this.sliderLength)
            //console.log(this.sliderLength)

            console.log(slide)
            let tempstrs = []
            tempstrs.push(slide.fileid)
            this.closeDocumentAction(tempstrs)
            //tts close
            //eventBus.$emit('tts-stop')
        },
        closeDocumentAction(strfiles) {
            var params = {}
            params.strdocids = strfiles
            constJ.reqCloseDocumentAction(params).then(res => {
                if (res.rtncode == 1) {
                    if (res.rltcode == 1) {
                        console.log('文档反馈发送成功')
                    } else {
                        console.log(res.rltdesc)
                    }
                } else {
                    console.log(res.rtndesc)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        sliderRemoveAll(sliders) {
            //console.log(sliders)
            let tempstrs = []
            for (let i = 0; i < sliders.length; i++) {
                var slide = sliders[i]
                this.swiperSlides.splice(this.swiperSlides.findIndex(item => item.fileid === slide.fileid), 1);
                tempstrs.push(slide.fileid)
            }
            //计算页码
            this.reloadFooter()
            this.$nextTick(function() {
                this.$refs.mySwiper.update();
                this.resize();
                this.expand = false;
                this.mainHidden = false
            })
            this.setSliderLength(this.swiperSlides.length);
            ////save to store
            this.setSysSliders(this.swiperSlides)

            //关闭多个文档
            this.closeDocumentAction(tempstrs)
            ////tts close
            //eventBus.$emit('tts-stop-force')
            eventBus.$emit('audiotts-stop-force')
            

        },
        showMainList() {
            this.$refs.search_Result.showlayer(["filename"], 500);
        },
        closeMainList() {
            this.$refs.search_Result.closelayer();
        },
        instance(type) {
            //CODE_FUNC_SCREEN = "000011" // 分屏浏览
            let CODE_FUNC_SCREEN = "000011"
            let pages = store.state.user.sysconfig.pages
            let permissions = store.state.user.permission
            if (permissions && permissions.length > 0) {
                let node = permissions.find(p => p.f === CODE_FUNC_SCREEN)
                pages = node.n //store.state.user.permission[10].n
            }
            console.log(pages)

            const title = '提示';
            let content = '<p>您打开的文档过多</p><p>目前支持同时打开' + pages + '个文档</p>';
            //试用用户分更多屏时提示（超3屏）
            const trial_content = '<p>您已同时打开' + pages + '个文档</p><p>要获得更多分屏权限，请登录/申请试用云擎账号</p>'
            const noMemberlevel_content = '<p>您已同时打开' + pages + '个文档</p><p>要获得更多分屏权限，请前去在线商城购买账号等级</p>'
            //正式用户分更多平屏时提示（超出已有分屏数）
            const member_content = '<p>您已同时打开' + pages + '个文档</p><p>要获得更多分屏权限，请前去在线商城购买VIP升级权限</p>'
            let accountStatus = store.state.user.accountstatus
            if (accountStatus === 0) {
                content = trial_content
            } else if (accountStatus === 100) {
                content = noMemberlevel_content
            } else if (accountStatus === 200) {
                content = member_content
            }
            switch (type) {
                case 'info':
                    this.$Modal.info({
                        title: title,
                        content: content
                    });
                    break;
                case 'success':
                    this.$Modal.success({
                        title: title,
                        content: content
                    });
                    break;
                case 'warning':
                    this.$Modal.confirm({
                        title: title,
                        content: content,
                        okText: accountStatus === 0 ? '登录/注册' : '在线商城',
                        cancelText: '关闭',
                        onOk: () => {
                            //this.removeAll()
                            if (accountStatus === 0) {
                                //弹出登录
                                this.$refs.topheader.showlogin()
                            } else {

                                //关闭所有分屏
                                this.removeAll()
                                this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })

                            }

                        }

                    });
                    break;
                case 'error':
                    this.$Modal.error({
                        title: title,
                        content: content
                    });
                    break;
            }
        },
        openNotice(nodesc, index) {
            this.$Notice.success({
                title: '分屏文档提示',
                //desc: nodesc ? '' : '文档在(第' + index + '屏),已打开',
                render: h => {
                    return h('span', [
                        '文档在',
                        h('span', {
                            domProps: {
                                innerHTML: `<span style="font-weight:bold;color:red;font-size:14px;" >(第` + index + `屏)</span>`,
                            }
                        }), ''
                    ])
                }
            });
        },

        setSliderOne() {
            let tempArr = [];
            let tempSliders = this.swiperSlides.shift()
            tempArr.push(tempSliders);
            this.swiperSlides = tempArr;
            //console.log(this.swiperSlides.length)
            this.$nextTick(function() {
                this.$refs.mySwiper.update();
                this.resize();
                //this.expand = false;
                //this.mainHidden = false
            })
            this.screenSet(false);
        },
        //主分屏展开的状态下,分屏自适应
        resize() {
            //console.log("expand:" + this.expand)

            if (!this.toggleFullScreen) {
                if (this.swiperSlides.length == 1) {
                    this.mainPageSpan = "12"
                    this.sliderMainPageSpan = "12"
                    this.nextSliderWidth = "100%"
                    //this.watchOverflow=true
                    this.hiddenButtonShow = true
                } else if (this.swiperSlides.length == 2) {
                    this.mainPageSpan = "8"
                    this.sliderMainPageSpan = "16"
                    this.nextSliderWidth = "49.9%"
                    //this.expand=false

                } else if (this.swiperSlides.length == 0) {
                    this.mainPageSpan = "24"
                    //this.sliderPageSpan = "0"
                    this.hiddenButtonShow = false
                } else {
                    this.mainPageSpan = "8"
                    this.sliderMainPageSpan = "16"
                    this.nextSliderWidth = "49.9%"
                }
                this.isButtonActive = false
            } else {
                this.toggleResize()
            }

        },
        toggleMenu() {
            this.expand = !this.expand
            if (this.expand === false) {
                this.toggleFullScreen = true
            }
            this.toggleResize()
            // console.log("toggle expand:" + this.expand)


        },
        //手动切换主屏为隐藏时,分屏自适应
        toggleResize() {
            console.log("this.swiperSlides.length:" + this.swiperSlides.length)
            if (!this.expand) {
                if (this.swiperSlides.length == 1) {
                    this.mainPageSpan = "0.5"
                    this.sliderMainPageSpan = "24"
                    this.nextSliderWidth = "99.9%"
                    this.isButtonActive = true
                    this.mainHidden = true
                    // this.getData()
                } else if (this.swiperSlides.length == 2) {
                    this.mainPageSpan = "0.5"
                    this.sliderMainPageSpan = "24"
                    this.nextSliderWidth = "49.9%"
                    this.isButtonActive = true
                    this.mainHidden = true
                } else if (this.swiperSlides.length > 2) {
                    //expand为true收起时,切换为全屏的3屏模式
                    this.mainPageSpan = "0.5"
                    this.sliderMainPageSpan = "24"
                    this.nextSliderWidth = "33.2%"
                    this.isButtonActive = true
                    this.mainHidden = true
                }

            } else {
                // this.resize()
                this.mainHidden = false
                this.toggleFullScreen = false
                this.resize()
                // console.log("展开")
                //this.hiddenButtonShow = false
            }
        },
        getTotalSliders() {
            return this.swiperSlides;
        },
        ...mapMutations([
            'setSliderLength', 'screenSet'
        ]),
        addReadFile(doc) {
            if (store.state.user.workbook.isContentChanged) {
                //console.log("addReadFile....")
                store.commit('addBookRead', doc)
            }
        },
    },
    components: {
        'TopMenu': TopMenu,
        'TopHeader': TopHeader,
        'MyDocument': MyDocument,
        'MyDrawer': Drawer,
        //aComponent,

    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        },
        myswiper() {
            return this.$refs.mySwiper
        },
        ...mapGetters(['sliderLength', 'sliderScreen'])
    },
    mounted() {
        this.swiper.detachEvents()
        this.swiper.scrollbar.$el.css('height', '15px');
        this.swiper.scrollbar.$dragEl.css('background', '#5cadff');
        eventBus.$on('statement_on', () => {
            this.feedback()
        });
        eventBus.$on('open_mobile', () => {
            this.openQR()
        })
        eventBus.$on('reset_player', (playerid) => {
            this.resetPlayState(playerid)
        })
        eventBus.$on('reset_player_on_finished', (playerid) => {
            this.resetPlayStateOnFinished(playerid)
        })
        eventBus.$on('lunch-file-match',()=>{
            this.isShowTopMenu=false
        })
        
    },
    beforeDestroy() {
        eventBus.$off('statement_on')
        eventBus.$off('open_mobile')
        eventBus.$off('reset_player')
        eventBus.$off('reset_player_on_finished')
        eventBus.$off('lunch-file-match')
    },
    created() {
        this.setFooterPad()
        this.isIE()
        // console.log('22222222222222===========================')

        // this.$Tools.getUrlBase64('/manual/sign1.png', function(base64){
        //     console.log('base64编码值',base64);//base64编码值
        // })
        //console.log(this.$Config)
    }
    //跳转至云端需要验证
    // beforeRouteLeave(to,from,next){
    //   // console.log(to)
    //   //console.log(store.state.user.userId.length)
    //   if (to.path === '/main/cloud/mycloud') {
    //     if (store.state.user.userId!==undefined && store.state.user.userId.length>1) {
    //       //console.log('go1...')
    //       next()
    //     }else{
    //       this.userLogin(to.path)
    //        next(false)
    //     }
    //   }else{
    //     next()
    //   }
    // }

}
</script>
<style lang="less" scoped>
html,
body {
    margin: 0px;
    padding: 0px;
    height: 100%;
}

.activeBar {
    width: 2%;
}

.activeBar1 {}

// div:hover {
//    .swiper-slide.swiper-slide-active  {
//       background-color:#515a6e;
//    }
// }
// .swiper-slide:nth-child(n+2) {
//   width: 50%;
// }
// .swiper-slide:nth-child(3n) {
//   width: 30%;
// }

// .swiper-slide {
//   width: 100%;
// }
// .swiper-slide:nth-child(2n) {
//     width: 40%;
// }
// .swiper-slide:nth-child(3n) {
//     width: 30%;
// }

.swiper-slide {
    font-size: 18px;
    background: white;
    // background: #515a6e;
    // height: 93.2vh;
    height: 100vh;

}

.addpage {
    //background: lightblue;
}

/* layout */
.layout {
    // border: 1px solid #d7dde4;
    border-left: none;
    border-top: none;
    background: #f5f7f9;
    position: relative;
    border-radius: 0px; //header背景无圆角
    overflow: hidden;
    // height: 100%;
}

.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}

.footer {
    //background: #515a6e;
    color: #F0F4FA;
    font-size: 12px;
    z-index: 101;
    text-align: left;
    // position:absolute;
    // height: 100px;
    // width: 100%;
    // top:100%;

    //padding: 5px 5px;
}


.content_g1 {
    background: #fff;
    height:95.2vh;
    overflow-y: auto;
}

.content {
    background: #fff;
    height:89.2vh;
    overflow-y: auto;
}
.content_f {
    background: #fff;
    height:100%;
    overflow-y: auto;
}


.content ivu-layout-content {
    padding: 0px !important;
}

.copyright {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-size: 14px;
}

#qrimg:hover {
    border: 1px solid #ff9900;
}
</style>